import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { loadPodcastWorkflowTemplate } from 'redux/modules/common/actions';
import { podcastWorkflowTemplateSelector } from 'redux/modules/entities';
import { Dispatch } from 'redux/types';
import { TemplateType, VideoTypes } from 'types';

const useEditAutomationTemplate = (
  templateId: string,
  templateType: TemplateType,
) => {
  const dispatch = useDispatch<Dispatch>();

  const template = useSelector(
    React.useMemo(() => podcastWorkflowTemplateSelector(templateId), [
      templateId,
    ]),
  );

  const checkTemplate = React.useCallback(
    (id: string, type: TemplateType) => {
      dispatch(loadPodcastWorkflowTemplate(id, type));
    },
    [dispatch],
  );

  React.useEffect(() => {
    checkTemplate(templateId, templateType);
  }, [templateId, templateType, checkTemplate]);

  const isEntireEpisodeAllowed = template?.compatibleVideoTypes.includes(
    VideoTypes.FULL_EPISODE,
  );

  return { isEntireEpisodeAllowed };
};

export default useEditAutomationTemplate;
